import React from "react";

export default function TopMargin() {
  return <div style={{ marginTop: "20px" }}></div>;
}
